<script>
import AgesSelect from "@/components/AgesSelect";

export default {
    name: "Ages",
    components: { AgesSelect },
    data() {
        return {
            ages: [],

            error: "",
        };
    },
    methods: {
        prevStep() {
            this.$router.push({ name: "Service" });
        },
        nextStep() {
            if (this.validate()) {
                this.$storage.setStorageSync("ages", this.ages);
                this.$router.push({ name: "Service location" });
            }
        },

        validate() {
            if (this.ages.length <= 0) {
                this.error = "Please select age";
            } else {
                this.error = "";
            }

            return this.error === "";
        },
    },
    mounted() {
        this.ages = this.$storage.getStorageSync("ages") || [];
    },
};
</script>

<template>
    <div class="ages-service mx-auto">
        <div class="mt-4 mb-5 service-steps">
            Step 2 of 5
        </div>

        <h2 class="mb-5">
            Ages
        </h2>

        <div class="mt-2 d-flex flex-column">
            <AgesSelect
                :hide-label="true"
                :default="ages"
                @update="(e) => this.ages = e"
                :error="error"
            />
        </div>

        <div class="mt-5 d-flex flex-row">
            <button @click="prevStep" class="ml-0 px-4 py-3 d-block btn-new btn-new-outline">
                Back
            </button>
            <button @click="nextStep" type="submit" class="ml-auto px-4 py-3 d-block btn-new">Next</button>
        </div>
    </div>
</template>

<style scoped>

</style>
